import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.32_@babel+core@7.28.5_@playwright+test@1.56.1_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.32_@babel+core@7.28.5_@playwright+test@1.56.1_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_components/LinkLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunityCard"] */ "/vercel/path0/src/app/(authenticated)/(member)/discovery/_components/CommunityCard.tsx");
